import { render, staticRenderFns } from "./NewTrip.vue?vue&type=template&id=4d60afca&scoped=true&"
import script from "./NewTrip.vue?vue&type=script&lang=js&"
export * from "./NewTrip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d60afca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/srv/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d60afca')) {
      api.createRecord('4d60afca', component.options)
    } else {
      api.reload('4d60afca', component.options)
    }
    module.hot.accept("./NewTrip.vue?vue&type=template&id=4d60afca&scoped=true&", function () {
      api.rerender('4d60afca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/NewTrip/NewTrip.vue"
export default component.exports